import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { AnalyticsEvent, trackEvent } from "@/services/analytics/amplitude"
import type { UpsellProduct } from "./resolveSidebarNav"

const MAILTO_SUBJECT: Record<UpsellProduct, string> = {
  mc: "Material Compliance freischalten",
  questionnaire: "Fragebogen-Automatisierung freischalten",
}

interface UpsellDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  source: "locked_entry" | "upsell_card"
  product: UpsellProduct
}

export const UpsellDialog = ({
  open,
  onOpenChange,
  source,
  product,
}: UpsellDialogProps) => {
  const { translate } = useTranslation()

  const handleContact = () => {
    trackEvent(AnalyticsEvent.MC_UPSELL_CONTACT_CLICKED, { source, product })
    window.location.href = `mailto:support@turnus.ai?subject=${encodeURIComponent(
      MAILTO_SUBJECT[product],
    )}`
    onOpenChange(false)
  }

  const titleKey =
    product === "mc" ? "SIDEBAR/UPSELL_TITLE" : "SIDEBAR/QUESTIONNAIRE_MODULE"
  const bodyKey =
    product === "mc"
      ? "SIDEBAR/UPSELL_DIALOG_BODY"
      : "SIDEBAR/QA_UPSELL_DIALOG_BODY"

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{translate(titleKey)}</DialogTitle>
          <DialogDescription>{translate(bodyKey)}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleContact}>
            {translate("SIDEBAR/UPSELL_CONTACT")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
